import { Route,BrowserRouter as Router, Routes } from 'react-router-dom';
import Chatbotview from './Chatbot/Chatbotview'
import Chatbot from './pages/Chatbot';
import WelcomeScreen from './pages/WelcomeScreen';
import Splash from './pages/Splash';
import Welcome1 from './pages/Welcome1';
import Welcome2 from './pages/Welcome2';
import Login from './pages/Login';

 
function App() {
  return (<>
  {/* <Login/>
  <Welcome1 />

  <Welcome2/>

  <Splash /> */}
  
  <Router>


    <Routes>

      <Route path='/' element={<Splash/>} />
      <Route path='/w' element={<Welcome1/>} />
      <Route path='/chat' element={<Chatbot/>} />
      
    </Routes>
  </Router>
  
  </>)
}
export default App;
